import React from "react";

export default function Chocolate() {
  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      
    </div>
  );
}

